import { combineReducers } from 'redux';

import connection from './connection';
import cloudSync from './cloudSync';

export default combineReducers({ connection, cloudSync });
